import { render, staticRenderFns } from "./friendManage.vue?vue&type=template&id=142e7f3d&scoped=true&"
import script from "./friendManage.vue?vue&type=script&lang=js&"
export * from "./friendManage.vue?vue&type=script&lang=js&"
import style0 from "./friendManage.vue?vue&type=style&index=0&id=142e7f3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142e7f3d",
  null
  
)

export default component.exports